import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/primeng';
import { KeyboardEvent } from 'ngx-bootstrap/utils/facade/browser';
import { Component, OnDestroy, OnInit, ViewChild, HostListener, EventEmitter, Output, ElementRef } from '@angular/core';

import * as $ from 'jquery';
import * as moment from 'moment';
import { smoothlyMenu } from '../helpers';
import 'jquery-slimscroll';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { PinService } from '../../services/pin.service';
import { PinItem, PinTypes } from '../../models/domain/pin';
import { AdvancedSearchItem } from '../../models/domain/advanced.search.item';

import { BillingCycleTypes } from '../../models/domain/invoice';
import { LicenseStatusTypes } from '../../models/domain/license';
import { AdvancedSearchResultMemberItemArray, GlobalSearchResults } from '../../models/domain/advanced.searche.results';
import { AdminHistoryService } from '../../services/admin.history.service';
import { AdminBrowseLogItem } from '../../models/ss-api/responses/admin.browse.logs.response';
import { LicenseManager } from '../../managers/License.manager';
import { SearchResultComponent } from '../components/search-result/search-result.component';
import { ExportDataManager } from '../../managers/export.data.manager';
import { MemberPersonTypes } from '../../models/domain/member';
import { Subscription } from 'rxjs';
import { TagService } from '../../services/tag.service';
import { Paginator } from '../components/paginator/paginator.component';
import { WindowSettings } from '../../../app/services/window-dialogs/window.settings';
import { WindowTypes } from '../../../app/services/window-dialogs/window.event';
import { WindowService } from '../../../app/services/window-dialogs/window.service';
import { SearchService } from '../../../app/services/search.service';
import { AdminSearchItemArray } from '../../../app/models/domain/admin.search.item';

class StoredSearchItem {
    Name?: String;
    SearchItem: AdvancedSearchItem;
    SearchSettings: AdvancedSearchItem;
    LastUpdated: Date;
}

interface checkBoxOption {
    Label: string;
    LabelHTML: string;
    Value: number;
}

@Component({
    selector: 'top-nav-bar',
    templateUrl: './topnavbar.component.html',
    styleUrls: ['./topnavbar.component.css'],
    // directives: [ SearchResultComponent ],

})
export class TopNavBarComponent implements OnInit, OnDestroy {

    @ViewChild('spLicenseKeysPanel') LicenseKeySuggestionsPanel: OverlayPanel;
    @ViewChild('spLicenseKeysTarget') LicenseKeySuggestionsTarget: HTMLElement;

    @ViewChild('SearchResultComponent') private mySearchResultComponent: SearchResultComponent;

    @ViewChild("topSearch") searchInput: ElementRef;

    @Output('ItemSelected') ItemSelected = new EventEmitter<boolean>();

    //Hotkey
    @HostListener('window:keydown.alt.s', ['$event'])
    searchHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.onClickSearchInput();
        setTimeout(()=>{ // this will make the execution after the above boolean has changed
            this.searchInput.nativeElement.focus();
          },0);          
    }


    SearchInputValue: string = '';

    IsBusy: boolean = false;

    isFullScreen: boolean = false;

    HasSearchResults: boolean = false;

    // EXPORT ITEM ARRAY
    exportItemArray: AdvancedSearchResultMemberItemArray = new AdvancedSearchResultMemberItemArray;

    // PIN ICON CLASSES
    private pinMember = 'fa-user';
    private pinDesigner = 'fa-users';
    private pinLicense = 'fa-drivers-license';
    private pinInvoice = 'fa-file';
    private pinCreditCard = 'fa-credit-card-alt';
    private pinTicket = 'fa-file';

    DefaultSearch: AdvancedSearchItem = new AdvancedSearchItem;
    SearchResultSettings: AdvancedSearchItem = new AdvancedSearchItem;

    // ADVANCED SEARCH VARIABLES
    isAdvancedSearch: boolean = false;
    AdvancedSearch: AdvancedSearchItem = new AdvancedSearchItem;
    SearchResult = new GlobalSearchResults<AdvancedSearchResultMemberItemArray>();
    showPresets: boolean = false;
    showName: boolean = true;
    showContact: boolean = true;
    showSales: boolean = true;
    showBilling: boolean = true;
    showProduct: boolean = true;
    showTags: boolean = true;

    // SEARCH MEMORY STUFF
    CurrentSearch: AdvancedSearchItem = new AdvancedSearchItem;

    SearchHistory: AdminSearchItemArray;
    SearchPresets: AdminSearchItemArray;

    // NECESSARY CHECKBOX BOOLEANS
    cycleMonthly: boolean = false;
    cycleYearly: boolean = false;
    cycleOneTime: boolean = false;
    sOpen: boolean = false;
    sRegistered: boolean = false;
    sCancelled: boolean = false;
    sCancelledOpen: boolean = false;
    sDisabled: boolean = false;
    sTransfered: boolean = false;
    sTerminated: boolean = false;

    salesRepOptions: checkBoxOption[];
    productOptions: checkBoxOption[];
    addOnProductOptions: checkBoxOption[];

    memberTypeOptions: checkBoxOption[];

    advancedSearchClickSub: Subscription;

    searchResultsSub: Subscription;

    onWindowServiceNavigate: Subscription;

    advancedSearchBillingAmount: string;

    DisplaySearchSettings: boolean = false;

	OnlySearchMembers: boolean = false;
	
    @ViewChild('paginator') paginator: Paginator;

	firstItem: number = 0;
    MaxSearchResults: number = 1000000;
    searchResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        public pinService: PinService,
        public historyService: AdminHistoryService,
        public tagService: TagService,
        private router: Router,
        private windowService: WindowService,
        private searchService: SearchService) {
    }

    ngOnInit() {
        // this.SearchResult.Data = new AdvancedSearchResultMemberItemArray();
        let latestSearch = this.searchService.GetLatestSearch();

        if (latestSearch.SearchItem) {
            this.SearchResult = this.searchService.SearchResults;
            if (latestSearch.SearchItem.IsAdvancedSearch) {
                this.isAdvancedSearch = true;
                this.AdvancedSearch = latestSearch.SearchItem;

                if (this.AdvancedSearch.NextBillDate) {
                    this.AdvancedSearch.NextBillDate = new Date(this.AdvancedSearch.NextBillDate);
                }

                if (this.AdvancedSearch.NextBillDateEnd) {
                    this.AdvancedSearch.NextBillDateEnd = new Date(this.AdvancedSearch.NextBillDateEnd);
                }

                if (this.AdvancedSearch.ExpirationDate) {
                    this.AdvancedSearch.ExpirationDate = new Date(this.AdvancedSearch.ExpirationDate);
                }

                if (this.AdvancedSearch.ExpirationDateEnd) {
                    this.AdvancedSearch.ExpirationDateEnd = new Date(this.AdvancedSearch.ExpirationDateEnd);
                }

                if (this.AdvancedSearch.CreationDate) {
                    this.AdvancedSearch.CreationDate = new Date(this.AdvancedSearch.CreationDate);
                }

                if (this.AdvancedSearch.CreationDateEnd) {
                    this.AdvancedSearch.CreationDateEnd = new Date(this.AdvancedSearch.CreationDateEnd);
                }
            } else {
                this.DefaultSearch = latestSearch.SearchItem;
                // this.SearchInputValue = this.DefaultSearch.SmartSearch;
            }

            if (this.SearchResult && this.SearchResult.Data) {
                this.HasSearchResults = true;
            }
        } else {
            this.AdvancedSearch.MemberType = new Array<MemberPersonTypes>();
            this.AdvancedSearch.MemberType.push(100);
            this.AdvancedSearch.MemberType.push(110);
            this.AdvancedSearch.MemberType.push(200);
            this.AdvancedSearch.MemberType.push(210);
            this.AdvancedSearch.MemberType.push(220);
        }

        // this.SearchHistory = this.searchService.SearchHistory;

        // this.SearchResultSettings = this.searchService.SearchSettings;
        this.RestoreDisplaySettings();
        // this.SearchPresets = this.searchService.LoadPresets();
        this.salesRepOptions = this.searchService.SalesReps;
        console.log("tpO", this.searchService.Products)
        this.productOptions = this.searchService.Products;
        this.addOnProductOptions = this.searchService.AddOnProducts;
        this.memberTypeOptions = this.searchService.MemberTypes;

        let presetDisposable = this.searchService.LoadPresets().subscribe(response => {
            this.SearchPresets = response.Data;
            presetDisposable.unsubscribe();
        });

        let historyDisposable = this.searchService.LoadHistory().subscribe(response => {
            this.SearchHistory = response.Data.reverse();
            historyDisposable.unsubscribe();
        });

        this.advancedSearchClickSub = this.gb.onAdvancedSearchClick.subscribe(response => {
            this.openAdvancedSearch();
        });

        this.searchResultsSub = this.gb.onSearchResults.subscribe(response => {
        });

        this.onWindowServiceNavigate = this.windowService.onNavigate.subscribe(response => {
            if (response)
                this.isFullScreen = false;
        });

        this.pinService.Refresh();
        this.tagService.LoadAllPossibleTags();
    }

    ngOnDestroy() {
        this.advancedSearchClickSub.unsubscribe();
    }

    toggleNavigation(): void {
        $('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    toggleRightSidebar(): void {
        $('#right-sidebar').toggleClass('sidebar-open');
    }

    onFocus(event: KeyboardEvent): void {
        this.onClickSearchInput();
    }

    detectKeys(event: KeyboardEvent) {

        this.onClickSearchInput();
        if (event.key == 'Escape')
            this.closeSearch(true);

        if (event.key == 'Enter')
            this.Search();

    }

    detectKeysAdv(event: KeyboardEvent): void {

        if (event.key == 'Escape')
            this.closeSearch(true);

        if (event.key == 'Enter')
            this.Search();
    }

    onClickSearchInput() {
        this.isFullScreen = true;
    }

    ShowDisplaySettings() {
        this.DisplaySearchSettings = !this.DisplaySearchSettings;
    }

    SaveDisplaySettings() {
        this.searchService.SaveDisplaySettings(this.SearchResultSettings);
    }

    RestoreDisplaySettings() {
        this.searchService.GetSearchSettings().then(response => {
            if (!response.Result) {
                let localSettings = JSON.parse(localStorage.getItem('SS_SearchSettings'));
                if (localSettings) {
                    this.SearchResultSettings = localSettings;
                } else {
                    this.SearchResultSettings = this.searchService.DefaultSearchSettings;
                }
                this.searchService.SaveDisplaySettings(this.SearchResultSettings);
            } else {
                this.SearchResultSettings = JSON.parse(response.Data.PreferenceValue);
                if (!this.SearchResultSettings) {
                    this.SearchResultSettings = this.searchService.DefaultSearchSettings;
                    this.searchService.SaveDisplaySettings(this.SearchResultSettings);
                }
            }
        });
    }

    openAdvancedSearch() {
        this.isFullScreen = true;
        this.isAdvancedSearch = true;

        if (this.searchService.ProductOverviewResults) {
            this.SearchResult = this.searchService.ProductOverviewResults;
            this.HasSearchResults = true;

            if (this.paginator) {
                this.paginator.resetPaginator();
            }
        }
    }

    closeSearch(resetInput: boolean = true): void {
        this.isFullScreen = false;
        this.DisplaySearchSettings = false;

        if (resetInput)
            this.SearchInputValue = '';
    }


    SearchItemSelected() {
        this.ItemSelected.emit(true);
        this.closeSearch(false);
    }


    Search(item?: StoredSearchItem, history?: boolean) {
        if (this.SearchInputValue.length > 0 || item || this.isAdvancedSearch) {
            let searchItem: AdvancedSearchItem;
            
            let historical = history ? history : true;

            this.IsBusy = true;
            this.HasSearchResults = false;

            this.paginator.resetPaginator();

            if (item) {
                this.resetSearch();
                searchItem = Object.assign({}, item.SearchItem);
                historical = false;
                this.isAdvancedSearch = searchItem.IsAdvancedSearch;

                if (searchItem.IsAdvancedSearch) {
                    this.AdvancedSearch = searchItem;
                } else {
                    this.SearchInputValue = this.GetSearchLabel(item.SearchItem);
                    this.DefaultSearch = searchItem;
                }

            } else {
                if (this.isAdvancedSearch) {
                    this.AdvancedSearch.IsAdvancedSearch = this.isAdvancedSearch;
                    if ( this.advancedSearchBillingAmount == '' || Number.isNaN( Number(this.advancedSearchBillingAmount) ) ) {
                        this.AdvancedSearch.BillingAmount = -1;
                    } else {
                        this.AdvancedSearch.BillingAmount = Number( this.advancedSearchBillingAmount );
                    }
                    searchItem = Object.assign({}, this.AdvancedSearch);
                } else {
                    this.DefaultSearch.IsAdvancedSearch = false;
                    this.DefaultSearch.SmartSearch = this.SearchInputValue;
                    searchItem = Object.assign({}, this.DefaultSearch);
                }
            }

            if (searchItem.NextBillDate == null) searchItem.NextBillDate = undefined;
            if (searchItem.NextBillDateEnd == null) searchItem.NextBillDateEnd = undefined;
            if (searchItem.ExpirationDate == null) searchItem.ExpirationDate = undefined;
            if (searchItem.ExpirationDateEnd == null) searchItem.ExpirationDateEnd = undefined;
            if (searchItem.CreationDate == null) searchItem.CreationDate = undefined;
            if (searchItem.CreationDateEnd == null) searchItem.CreationDateEnd = undefined;

            searchItem.MaxRecords = 100000;

            searchItem.OnlySearchMembers = this.OnlySearchMembers;

            let disposable = this.searchService.StartSearch(searchItem).subscribe(response => {
                this.IsBusy = false;
                this.HasSearchResults = true;
                this.SearchResult = response.Data;

                let historyDisposable = this.searchService.LoadHistory().subscribe(response => {
                    this.SearchHistory = response.Data.reverse();
                    historyDisposable.unsubscribe();
                });

                this.paginator.resetPaginator();
                disposable.unsubscribe();
            });
        }
    }

    RepeatSearch(id: number) {
        this.IsBusy = true;
        this.HasSearchResults = false;

        let disposable = this.searchService.RepeatSearch(id).subscribe(response => {
            this.IsBusy = false;
            this.HasSearchResults = true;
            this.SearchResult = response.Data;

            this.paginator.resetPaginator();
            disposable.unsubscribe();
        });
    }

    SaveAsPreset() {
        let searchItem: AdvancedSearchItem;
        let vm = this;

        this.sweetAlert.swal(
            {
              title: 'Save As Preset',
              input: 'text',
              inputValue: '',
              showCancelButton: true,
              preConfirm: (response) => {
                  return new Promise(function(resolve, reject) {
                    if (response.length > 0) {
                        if (vm.isAdvancedSearch) {
                            vm.AdvancedSearch.IsAdvancedSearch = vm.isAdvancedSearch;
                            if ( vm.advancedSearchBillingAmount == '' || Number.isNaN( Number(vm.advancedSearchBillingAmount) ) ) {
                                vm.AdvancedSearch.BillingAmount = -1;
                            } else {
                                vm.AdvancedSearch.BillingAmount = Number( vm.advancedSearchBillingAmount );
                            }
                            searchItem = Object.assign({}, vm.AdvancedSearch);
                        } else {
                            vm.DefaultSearch.IsAdvancedSearch = false;
                            vm.DefaultSearch.SmartSearch = vm.SearchInputValue;
                            searchItem = Object.assign({}, vm.DefaultSearch);
                        }

                        let subscription = vm.searchService.AddSearchPreset(response, searchItem).subscribe(response => {
                            let disposable = vm.searchService.LoadPresets().subscribe(response => {
                                vm.SearchPresets = response.Data;
                                disposable.unsubscribe();
                            });

                            subscription.unsubscribe();
                        });
                        resolve();
                    } else {
                        alert('Please enter a name to save this preset');
                        reject();
                    }
                  });
                }
            }).then((response: any) => {
            }, (dismiss) => {
              return;
            }
        );
    }

    DeletePreset(id: number) {
        this.sweetAlert.swal({
            title: 'Are you sure?',
            text: 'Deleting this preset cannot be undone.',
            type: 'warning',
            showCancelButton: true
        }).then((response: any) => {
            let dispose = this.searchService.DeleteSearchPreset(id).subscribe(response => {
                let disposable = this.searchService.LoadPresets().subscribe(response => {
                    this.SearchPresets = response.Data;
                    disposable.unsubscribe();
                });
                dispose.unsubscribe();
            });
        }, (dismiss) => {
        });
    }

    HistoryClick(item: AdminBrowseLogItem) {

        if (item.LicenseID != undefined && item.LicenseID > 0) {
            // this.licenseManager.Load(item.LicenseKey);
            let windowSettings = new WindowSettings();
            windowSettings.Height = 900;
            windowSettings.Width = 1240;

            this.windowService.OpenWindow<string>(WindowTypes.License, item.LicenseKey, windowSettings);

        } else if (item.MemberID != undefined && item.MemberID > 0) {
            this.router.navigate(['/member-profile', item.MemberID]);
        }
    }

    GetHistoryTitle(item: AdminBrowseLogItem): string {
        if (item.LicenseID != undefined && item.LicenseID > 0) {
            return item.MemberName + ' : ' + item.LicenseKey;
        } else if (item.MemberID != undefined && item.MemberID > 0) {
            return item.MemberName;
        }
    }

    GetSearchLabel(item: AdvancedSearchItem): string {
        if (item.IsAdvancedSearch) {

            let name = '';
            let properties = [
                'FirstName',
                'LastName',
                'Email',
                'CompanyName',
                'Address1',
                'City',
                'State',
                'ZipCode',
                'Country',
                'Phone1',
                'Phone2',
                'Fax',
                'CreditCardLastFour',
                'CDKey',
                'DesignerName',
                'Version'
            ];

            properties.forEach(function(prop) {
                if (item[prop]) name = item[prop];
            });

            if (name == '') name = 'Adv Search';

            return name;

        } else if (item.SmartSearch) {
            return item.SmartSearch;
        } else {
            return 'Adv Search';
        }
    }


    LoadPins() {
        this.pinService.Refresh();
    }

    LoadHistory() {
        this.historyService.Refresh();
    }

    PinDelete(pin: PinItem) {
        this.api.PinDelete(pin.ID).subscribe();
    }

    PinClick(pin: PinItem) {
        // console.log("pin", PinItem);

        switch (pin.PinType) {

            // member
            case PinTypes.Member:
                this.router.navigate(['/member-profile', pin.RelationID]);
                return;

            // credit card
            case PinTypes.CreditCard:
                alert('not implemented');
                return;

            // license
            case PinTypes.License:
                this.IsBusy = true;
                let manager = new LicenseManager();
                manager.OnDataLoaded.subscribe(response => {
                    this.IsBusy = false;
                });
                manager.Load(pin.RelationID.toString(), true);
                return;

            // invoice
            case PinTypes.Invoice:
                alert('not implemented');
                return;

            // ticket
            case PinTypes.Ticket:
                // let ticket = new TicketManager(pin.RelationID);
                return;
        }
    }

    GetPinItemIconClass(pin: PinItem): string {

        switch (pin.PinType) {

            // member
            case PinTypes.Member:
                if (pin.RelationInfo1 != null)
                    return this.pinDesigner;
                else
                    return this.pinMember;

            // credit card
            case PinTypes.CreditCard:
                return this.pinCreditCard;

            // credit card
            case PinTypes.License:
                return this.pinLicense;

            // credit card
            case PinTypes.Invoice:
                return this.pinInvoice;

            // ticket
            case PinTypes.Ticket:
                return this.pinTicket;
        }
    }


    @HostListener('document:keyup', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x === 27) {
            this.closeSearch(true);
        }
    }


    exportCurrentToCSV() {

        let exportManager = new ExportDataManager();
        exportManager.ExportSearchResults(this.SearchResultSettings, this.SearchResult.Data);

    }

    exportSelectedToCSV() {

        let exportManager = new ExportDataManager();
        exportManager.ExportSearchResults(this.SearchResultSettings, this.exportItemArray);

    }

    exportAllToCSV() {

        let exportAllSearch = Object.assign({}, this.CurrentSearch);

        exportAllSearch.SkipRecords = 0;
        exportAllSearch.MaxRecords = this.MaxSearchResults;

        this.IsBusy = true;

        let subscription = this.api.SearchAdvanced(exportAllSearch).subscribe(response => {
            subscription.unsubscribe();

            if (!response.Result) {
                this.IsBusy = false;
                return;
            }
            // let exportResults : AdvancedSearchResultMemberItemArray = response.Data;
            // this.SearchResult = response.Data;
            let exportManager = new ExportDataManager();
            exportManager.ExportSearchResults(this.SearchResultSettings, response.Data.Data);

            this.IsBusy = false;

        }, error => {
            this.IsBusy = false;
            this.HasSearchResults = false;
        });

    }

    resetFields() {
        this.AdvancedSearch.TagIDs = [];
        this.AdvancedSearch.FirstName = undefined;
        this.AdvancedSearch.LastName = undefined;
        this.AdvancedSearch.Email = undefined;
        this.AdvancedSearch.MemberID = undefined;
        this.AdvancedSearch.CompanyName = undefined;
        this.AdvancedSearch.Address1 = undefined;
        this.AdvancedSearch.City = undefined;
        this.AdvancedSearch.State = undefined;
        this.AdvancedSearch.ZipCode = undefined;
        this.AdvancedSearch.Country = undefined;
        this.AdvancedSearch.Phone1 = undefined;
        this.AdvancedSearch.Phone2 = undefined;
        this.AdvancedSearch.Fax = undefined;
        this.AdvancedSearch.CreditCardLastFour = undefined;
        this.AdvancedSearch.BillingAmount = undefined;
        this.advancedSearchBillingAmount = undefined;
        this.AdvancedSearch.NextBillDate = undefined;
        this.AdvancedSearch.NextBillDateEnd = undefined;
        this.AdvancedSearch.ExpirationDate = undefined;
        this.AdvancedSearch.ExpirationDateEnd = undefined;
        this.AdvancedSearch.CDKey = undefined;
        this.AdvancedSearch.Version = undefined;
        this.AdvancedSearch.LiveHubVersion = undefined;
        this.AdvancedSearch.DesignerName = undefined;
        this.AdvancedSearch.CreationDate = undefined;
        this.AdvancedSearch.CreationDateEnd = undefined;
    }

    resetSearch() {
        this.AdvancedSearch.BillingCycle = new Array<BillingCycleTypes>();
        this.AdvancedSearch.ProductID = [];
        this.AdvancedSearch.SalesRepID = [];
        this.AdvancedSearch.TagIDs = [];
        this.AdvancedSearch.MemberType = new Array<MemberPersonTypes>();
        this.AdvancedSearch.MemberType.push(100);
        this.AdvancedSearch.MemberType.push(110);
        this.AdvancedSearch.MemberType.push(200);
        this.AdvancedSearch.MemberType.push(210);
        this.AdvancedSearch.MemberType.push(220);
        this.AdvancedSearch.ExcludeFreeLicenses = undefined;
        this.cycleMonthly = false;
        this.cycleYearly = false;
        this.cycleOneTime = false;
        this.sOpen = false;
        this.sRegistered = false;
        this.sCancelled = false;
        this.sCancelledOpen = false;
        this.sDisabled = false;
        this.sTransfered = false;
        this.sTerminated = false;
        this.AdvancedSearch.IncludeDesignerLicenses = undefined;
        this.AdvancedSearch.FirstName = undefined;
        this.AdvancedSearch.LastName = undefined;
        this.AdvancedSearch.Email = undefined;
        this.AdvancedSearch.MemberID = undefined;
        this.AdvancedSearch.CompanyName = undefined;
        this.AdvancedSearch.Address1 = undefined;
        this.AdvancedSearch.City = undefined;
        this.AdvancedSearch.State = undefined;
        this.AdvancedSearch.ZipCode = undefined;
        this.AdvancedSearch.Country = undefined;
        this.AdvancedSearch.Phone1 = undefined;
        this.AdvancedSearch.Phone2 = undefined;
        this.AdvancedSearch.Fax = undefined;
        this.AdvancedSearch.CreditCardLastFour = undefined;
        this.AdvancedSearch.BillingAmount = undefined;
        this.advancedSearchBillingAmount = undefined;
        this.AdvancedSearch.NextBillDate = undefined;
        this.AdvancedSearch.NextBillDateEnd = undefined;
        this.AdvancedSearch.ExpirationDate = undefined;
        this.AdvancedSearch.ExpirationDateEnd = undefined;
        this.AdvancedSearch.CDKey = undefined;
        this.AdvancedSearch.Version = undefined;
        this.AdvancedSearch.LiveHubVersion = undefined;
        this.AdvancedSearch.DesignerName = undefined;
        this.AdvancedSearch.CreationDate = undefined;
        this.AdvancedSearch.CreationDateEnd = undefined;
    }


    toggleShowItem(toggleBool: boolean) {
        toggleBool = !toggleBool;
    }

    setSalesRep(repID: any) {

        if (this.AdvancedSearch.SalesRepID == undefined)
            this.AdvancedSearch.SalesRepID = [];

        let index = this.AdvancedSearch.SalesRepID.indexOf(repID);

        if (index < 0)
            this.AdvancedSearch.SalesRepID.push(repID);
        else
            this.AdvancedSearch.SalesRepID.splice(index, 1);

    }

    IsSalesRepChecked(item) {
        if (this.AdvancedSearch.SalesRepID && this.AdvancedSearch.SalesRepID.indexOf(item.Value) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    IsTagChecked(item) {
        if (this.AdvancedSearch.TagIDs && this.AdvancedSearch.TagIDs.indexOf(item.ID) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    setTags(tagID: any) {
        if (this.AdvancedSearch.TagIDs == undefined)
            this.AdvancedSearch.TagIDs = [];

        let index = this.AdvancedSearch.TagIDs.indexOf(tagID);

        if (index < 0)
            this.AdvancedSearch.TagIDs.push(tagID);
        else
            this.AdvancedSearch.TagIDs.splice(index, 1);
    }

    setProduct(productID: any) {

        if (this.AdvancedSearch.ProductID == undefined)
            this.AdvancedSearch.ProductID = [];

        let index = this.AdvancedSearch.ProductID.indexOf(productID);

        if (index < 0)
            this.AdvancedSearch.ProductID.push(productID);
        else
            this.AdvancedSearch.ProductID.splice(index, 1);
    }

    IsProductTypeChecked(item) {
        if (this.AdvancedSearch.ProductID && this.AdvancedSearch.ProductID.indexOf(item.Value) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    setMemberType(typeID: any) {
        if (!this.AdvancedSearch.MemberType) {
            this.AdvancedSearch.MemberType = new Array<MemberPersonTypes>();
        }

        if (this.AdvancedSearch.MemberType.indexOf(typeID) < 0)
            this.AdvancedSearch.MemberType.push(typeID);
        else
            this.AdvancedSearch.MemberType.splice(this.AdvancedSearch.MemberType.indexOf(typeID), 1);
    }

    setBillingCycle(billingCycleName: string) {
        let billingCycle: BillingCycleTypes = BillingCycleTypes.Monthly;
        if (billingCycleName == 'Yearly')
            billingCycle = BillingCycleTypes.Annually;
        else if (billingCycleName == 'OneTime')
            billingCycle = BillingCycleTypes.OneTime;

        if (!this.AdvancedSearch.BillingCycle) {
            this.AdvancedSearch.BillingCycle = new Array<BillingCycleTypes>();
        }
        let index = this.AdvancedSearch.BillingCycle.indexOf(billingCycle);

        if (index < 0)
            this.AdvancedSearch.BillingCycle.push(billingCycle);
        else
            this.AdvancedSearch.BillingCycle.splice(index, 1);

    }

    setStatus(status: string) {
        let newStatus: LicenseStatusTypes = LicenseStatusTypes.Open;
        switch (status) {
            case 'registered':
                newStatus = LicenseStatusTypes.Registered;
                break;
            case 'cancelled':
                newStatus = LicenseStatusTypes.Cancelled;
                break;
            case 'cancelledopen':
                newStatus = LicenseStatusTypes.CancelledOpen;
                break;
            case 'disabled':
                newStatus = LicenseStatusTypes.Disabled;
                break;
            case 'transfered':
                newStatus = LicenseStatusTypes.Transfered;
                break;
            case 'terminated':
                newStatus = LicenseStatusTypes.Terminated;
                break;
            case 'doesnotexist':
                newStatus = LicenseStatusTypes.DoesNotExist;
                break;
            default:
                newStatus = LicenseStatusTypes.Open;
                break;
        }

        if (!this.AdvancedSearch.Status) {
            this.AdvancedSearch.Status = new Array<LicenseStatusTypes>();
        }

        if (this.AdvancedSearch.Status.find(x => x == newStatus) == undefined)
            this.AdvancedSearch.Status.push(newStatus);
        else
            this.AdvancedSearch.Status.splice(this.AdvancedSearch.Status.indexOf(newStatus), 1);
    }

    ValidateNextBillDate() {
        let ctx = this;
        let start = this.AdvancedSearch.NextBillDate;
        let end = this.AdvancedSearch.NextBillDateEnd;

        if (!end || moment(start).isAfter(moment(end))) {
            setTimeout(function() {
                ctx.AdvancedSearch.NextBillDateEnd = ctx.AdvancedSearch.NextBillDate;
            }, 100);
        }
    }

    ValidateEndDate() {
        let ctx = this;
        let start = this.AdvancedSearch.ExpirationDate;
        let end = this.AdvancedSearch.ExpirationDateEnd;

        if (!end || moment(start).isAfter(moment(end))) {
            setTimeout(function() {
                ctx.AdvancedSearch.ExpirationDateEnd = ctx.AdvancedSearch.ExpirationDate;
            }, 100);
        }
    }

    ValidateStartDate() {
        let ctx = this;
        let start = this.AdvancedSearch.CreationDate;
        let end = this.AdvancedSearch.CreationDateEnd;

        if (!end || moment(start).isAfter(moment(end))) {
            setTimeout(function() {
                ctx.AdvancedSearch.CreationDateEnd = ctx.AdvancedSearch.CreationDate;
            }, 100);
        }
    }

    UpdateSearchSettings() {
        this.searchService.UpdateSearchSettings(this.SearchResultSettings);
        // localStorage.setItem("crm_SearchSettingsItem", JSON.stringify(this.SearchResultSettings));
    }


    updatedExportItemArray(event: AdvancedSearchResultMemberItemArray) {
        this.exportItemArray = event;
    }

    ignorePaginateSearch: boolean = false;

    isMemberTypeChecked(item: checkBoxOption): Boolean {
        if (this.AdvancedSearch.MemberType && this.AdvancedSearch.MemberType.indexOf(item.Value) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    paginateSearch(e) {
        this.firstResult = e.page * e.rows;
		
		this.lastResult = this.firstResult + e.rows;
		if (this.lastResult > this.SearchResult.TotalRecordsAvailable )
			this.lastResult = this.SearchResult.TotalRecordsAvailable;

        this.ScrollSearchToTop();
    }


    @ViewChild('SearchResultsContainer') SearchResultsContainer: ElementRef;
    ScrollSearchToTop() {
        this.SearchResultsContainer.nativeElement.scrollTop = 0;
    }


    paginatorTest(event: any) {
        this.paginator.changePageToFirst(event);
    }

}
